import { useLocation, useHistory } from 'react-router-dom';
import { queryParamsToObject, serializeParams } from 'utils';
import { ROUTE_PARAM_KEYS } from 'router/queryRouteCodec';

function fixQueryString(url) {
  return `?${url
    .split('?')
    .filter((part) => !!part)
    .join('&')}`;
}

// In query-router mode the SPA route lives in window.location.search (e.g.
// `?eventId=<id>/tickets/<date>`). Those router-owned keys must not be mistaken for
// application params when we merge the host query string in below, so strip them
// first. A no-op in hash/browser mode, where no route key is present.
function stripRouteParams(search) {
  const params = new URLSearchParams(search);
  ROUTE_PARAM_KEYS.forEach((key) => params.delete(key));
  const serialized = params.toString();
  return serialized ? `?${serialized}` : '';
}

/**
 * @deprecated Use `useQueryParamsObject` in utils/url instead.
 */
const useSearchQueryParams = () => {
  const location = useLocation();
  const history = useHistory();
  // URLSearchParams overwrites params when they are duplicated
  // therefore, if we want params in location.search (from react-router-dom)
  // to take precedence over the ones in window.location.search
  // we need to concat window.location.search before
  const searchParams = queryParamsToObject(
    fixQueryString(
      `${stripRouteParams(window.location.search)}${location.search || ''}`,
    ),
  );

  const setParam = (name, value) => {
    searchParams[name] = value;
    history.replace({
      search: serializeParams(searchParams),
    });
  };

  const replaceParams = (paramsObject) => {
    history.replace({
      search: serializeParams(paramsObject),
    });
  };

  return { searchParams, setParam, replaceParams };
};

export default useSearchQueryParams;
